import Layout from "@/layout";
export default {
  meta: {
    title: "企业",
    icon: "b-qy",
  },
  path: "/entryTis",
  component: Layout,
  children: [
    {
      path: "/entryTis/index",
      name: "entryTisIndex",
      component: () => import("@/views/entryTis/index"),
      meta: {
        title: "TIS机构管理",
        auth: [],
        img: "tis",
      },
    },
    {
      path: "/entryTis/add",
      name: "entryTisAdd",
      hide: true,
      component: () => import("@/views/entryTis/add"),
      meta: {
        // title: 'TIS机构管理',
        // confirm: "新增TIS机构",
        view: "查看TIS机构",
        // tisConfirm: "新增TIS机构",
        // confirm2: "新增TIS机构",
        add: "新增TIS机构",
        edit: "修改TIS机构",
        auth: [],
        img: "idi",
        auth: [],
        img: "yhgl",
      },
      props: (route) => {
        return route.query;
      },
    },
    {
      path: "/BxCom/index",
      name: "BxCom",
      component: () => import("@/views/BxCom/index"),
      meta: {
        title: "保险公司",
        auth: [],
        img: "tis",
      },
    },
    {
      path: "/BxCom/add",
      name: "BxComAdd",
      hide: true,
      component: () => import("@/views/BxCom/add"),
      meta: {
        // title: 'TIS机构管理',
        // confirm: "新增TIS机构",
        view: "查看保险公司",
        // tisConfirm: "新增TIS机构",
        // confirm2: "新增TIS机构",
        add: "新增保险公司",
        edit: "修改保险公司",
        auth: [],
        img: "idi",
        auth: [],
        img: "yhgl",
      },
      props: (route) => {
        return route.query;
      },
    },
    {
      path: "/BxComAdmin/add",
      name: "BxComAdminAdd",
      hide: true,
      component: () => import("@/views/BxComAdmin/add"),
      meta: {
        // title: 'TIS机构管理',
        // confirm: "新增TIS机构",
        view: "查看保险公司",
        // tisConfirm: "新增TIS机构",
        // confirm2: "新增TIS机构",
        add: "新增保险公司",
        edit: "修改保险公司",
        auth: [],
        img: "idi",
        auth: [],
        img: "yhgl",
      },
      props: (route) => {
        return route.query;
      },
    },
  ],
};
